/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";
import { DatePicker, ConfigProvider } from "antd";
import thTH from "antd/locale/th_TH";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/th";

dayjs.locale("th");
dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;



const formatDisplay = (v) => v.format('DD/MM/YYYY');

export default function DateRangePickerAntd({
  label = "ระยะเวลา",
  value,
  onChange,
  className,
}) {
  const antValue = useMemo(() => {
    if (!value) return null;
    const parseToDayjs = (v) => {
      if (!v) return null;
      if (v instanceof Date) return dayjs(v);
      const d = dayjs(v, "YYYY-MM-DD", true);
      return d.isValid() ? d : dayjs(v);
    };
    const s = parseToDayjs(value.start);
    const e = parseToDayjs(value.end);
    if (!s && !e) return null;
    return [s, e];
  }, [value?.start, value?.end]);

  const handleChange = (dates) => {
    if (!dates) {
      onChange?.({ start: null, end: null });
      return;
    }
    const [s, e] = dates;
    onChange?.({
      start: s ? s.toDate() : null,
      end: e ? e.toDate() : null,
    });
  };

  return (
    <div className={className}>
      <ConfigProvider locale={thTH}>
        <RangePicker
          value={antValue}
          onChange={handleChange}
          format={'DD/MM/YYYY'}
          placeholder={["เริ่มต้น", "สิ้นสุด"]}
          allowClear={false}
          inputReadOnly
          className="h-[48px] w-[250px] 2xl:w-[250px]"
          style={{ borderRadius: 12 }}
        />
      </ConfigProvider>
    </div>
  );
}
